function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 24.001C37.2548 24.001 48 34.7461 48 48.001L1.04907e-06 48.001C4.69686e-07 34.7461 10.7452 24.001 24 24.001Z",
  fill: "url(#paint0_linear_feat2)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 24.001C37.2548 24.001 48 13.2558 48 0.000976562H0C0 13.2558 10.7452 24.001 24 24.001Z",
  fill: "url(#paint1_linear_feat2)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_feat2",
  x1: 0.00000104907,
  y1: 48.001,
  x2: 48,
  y2: 48.001,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8EE12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEB23F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEC062"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_feat2",
  x1: 38,
  y1: 24.001,
  x2: 38,
  y2: 0.000976088,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFD80"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFCF58"
})));

var SvgFeature2 = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFeature2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/feature-2.980f410d.svg";
export { ForwardRef as ReactComponent };